import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";

import { useTranslation } from "react-i18next";

const CardsList = ({ cards, loading, currentIndex, setCurrentIndex, error, selectedCard, setSelectedCard }) => {
  const {t , i18n} = useTranslation();
  const handlePrev = () => {
    if (cards && currentIndex > 0) {
      const newIndex = currentIndex - 1;
      setCurrentIndex(newIndex);
      setSelectedCard(cards[newIndex]);
    }
  };

  const handleNext = () => {
    if (cards && currentIndex < cards.length - 1) {
      const newIndex = currentIndex + 1;
      setCurrentIndex(newIndex);
      setSelectedCard(cards[newIndex]);
    }
  };
  if (loading) return <p>{t("loading")}...</p>;
  if (error) return <p className="text-red-500">{t("error")}: {error}</p>;


  return (
    <div className="flex flex-col items-center gap-4 W-[20.34rem] 
    lg:w-[17.25rem] ">
      <div className="relative W-[20.34rem] lg:w-[17.25rem] border 
      rounded-2xl bg-[##EFEEEC]">
        <img
          src={selectedCard?.website_image}
          alt={i18n.language === "en"
                  ? selectedCard?.english_name
                  : selectedCard?.arabic_name}
          className="w-full W-[20.34rem] lg:w-[17.25rem] h-[20.34rem] 
          lg:h-[17.25rem]  object-cover rounded-2xl"
        />
        {cards.length >= 1 && (
          <>
            <button
              className="absolute left-2 top-1/2 transform -translate-y-1/2
               p-2 bg-white rounded-full  disabled:opacity-50"
              onClick={handlePrev}
              disabled={currentIndex === 0}
            >
              <IoIosArrowBack className="w-3 h-3" />
            </button>
            <button
              className="absolute right-2 top-1/2 transform -translate-y-1/2 
              p-2 bg-white rounded-full disabled:opacity-50"
              onClick={handleNext}
              disabled={currentIndex === cards.length - 1}
            >
              <IoIosArrowForward className="w-3 h-3" />
            </button>
          </>
        )}
      </div>
      {!loading && cards && cards.length >= 1 && (
        <div className="flex gap-2 overflow-x-auto w-full h-[5rem] items-center justify-start">
          {cards.map((card, index) => (
            <img
              key={index}
              src={card.website_image}
              alt={i18n.language === "en"
                  ? card?.english_name
                  : card?.arabic_name}
              className={`w-[4.75rem] h-[4.75rem] lg:w-[4.375rem] 
                            lg:h-[4.375rem] object-cover rounded-lg cursor-pointer border-2 
                            ${selectedCard.id === card.id ? "border-blue-500" : "border-transparent"
                } shadow shadow-black`}
              onClick={() => {
                setSelectedCard(cards[index]);
                setCurrentIndex(index);
              }}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default CardsList;
